const formatComma = (value: number) => {
   
    return value.toLocaleString(undefined, {minimumFractionDigits: 2}) 
    // → "30,000.65" where English is the default language, or
    // → "30.000,65" where German is the default language, or
    // → "30 000,65" where French is the default language
}
export default formatComma